import Layout from "../components/Layout";
import ScrollReveal from "../components/ScrollReveal";
import { Link } from "react-router-dom";
import { ArrowRight, Target, Eye, Heart, Users, Award, Building2 } from "lucide-react";

export default function About() {
  const stats = [
    { value: "30+", label: "Years Experience" },
    { value: "30+", label: "Completed Projects" },
    { value: "7.5L", label: "Sq Ft Constructed" },
    { value: "1000+", label: "Happy Families" },
  ];

  const values = [
    { icon: Target, title: "Quality First", description: "We never compromise on the quality of materials or construction practices." },
    { icon: Eye, title: "Transparency", description: "Open communication and honest dealings with all our clients." },
    { icon: Heart, title: "Customer Care", description: "Your satisfaction is our top priority from design to handover." },
  ];

  return (
    <Layout>
      {/* Hero */}
      <section
        className="relative py-20 md:py-32 text-white bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1759078802258-8e3703c13415?w=1600&h=600&fit=crop')" }}
      >
        <div className="absolute inset-0 bg-primary/88" />
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <ScrollReveal>
              <h1 className="text-5xl md:text-6xl font-bold mb-6">About Arrow Construction</h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                A trusted name in real estate development across Mumbai, Navi Mumbai, and beyond — delivering quality homes and commercial spaces since our inception.
              </p>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-secondary">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <div className="text-center" data-testid={`stat-${i}`}>
                  <div className="text-4xl font-bold text-primary mb-1">{stat.value}</div>
                  <div className="text-sm text-primary/80 font-medium">{stat.label}</div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 md:py-28 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center max-w-5xl mx-auto">
            <ScrollReveal direction="right">
              <div>
                <h2 className="text-4xl font-bold text-primary mb-6">Our Story</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Arrow Construction was founded with a singular mission — to build homes and spaces that stand the test of time. We have been at the forefront of residential construction in Mumbai and Navi Mumbai, delivering projects that combine modern design with structural excellence.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-6">
                  From affordable housing to premium residences, every project we undertake reflects our commitment to quality, timely delivery, and customer satisfaction.
                </p>
                <Link
                  to="/projects"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:opacity-90 transition-opacity"
                >
                  View Our Projects <ArrowRight size={18} />
                </Link>
              </div>
            </ScrollReveal>
            <ScrollReveal direction="left">
              <div className="rounded-xl overflow-hidden shadow-xl">
                <img
                  src="https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&h=400&fit=crop"
                  alt="Arrow Construction team"
                  className="w-full h-80 object-cover"
                />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-28 bg-gray-50">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-primary mb-4">Our Values</h2>
              <p className="text-muted-foreground text-lg max-w-xl mx-auto">The principles that guide everything we do.</p>
            </div>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {values.map((v, i) => {
              const Icon = v.icon;
              return (
                <ScrollReveal key={i} delay={i * 0.1}>
                  <div className="bg-white p-8 rounded-xl shadow-sm border border-border text-center hover:shadow-md transition-shadow">
                    <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mx-auto mb-5">
                      <Icon size={30} className="text-secondary" />
                    </div>
                    <h3 className="text-xl font-bold text-primary mb-3">{v.title}</h3>
                    <p className="text-muted-foreground leading-relaxed">{v.description}</p>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}
